import { isPlatformBrowser } from '@angular/common';
import type { OnChanges, OnDestroy } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  PLATFORM_ID,
} from '@angular/core';
import type { HeartbeatTrackingCancellation } from './tracking.model';
import { Tracking } from './tracking.service';

@Component({
  selector: `fl-heartbeat-tracking`,
  template: ` <ng-container></ng-container> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeartbeatTrackingComponent implements OnChanges, OnDestroy {
  @Input() name: string;
  @Input() referenceType?: string;
  @Input() referenceId?: number | string;

  cancel: HeartbeatTrackingCancellation;

  constructor(
    private tracking: Tracking,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  async ngOnChanges(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      if (this.cancel) {
        this.cancel();
      }
      this.cancel = await this.tracking.trackHeartbeat(
        this.name,
        this.referenceType,
        this.referenceId?.toString(),
      );
    }
  }

  ngOnDestroy(): void {
    this.cancel?.();
  }
}
